import { Controller } from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['content', 'collapseButton', 'expandButton']

  collapse() {
    $(this.contentTarget).stop(true, true).slideUp(200)
    this.collapseButtonTarget.classList.add('hidden')
    this.expandButtonTarget.classList.remove('hidden')
  }

  expand() {
    this.dispatch('expand', { detail: { expandedSection: this } })

    // For the first expand to animate, keep the hidden class until slideDown starts.
    // jQuery will set inline display so the animation runs; then we clean up the class.
    $(this.contentTarget)
      .stop(true, true)
      .slideDown(200, () => {
        this.contentTarget.classList.remove('hidden')
      })

    this.collapseButtonTarget.classList.remove('hidden')
    this.expandButtonTarget.classList.add('hidden')
  }

  toggle() {
    const isHidden = this.contentTarget.offsetParent === null
    isHidden ? this.expand() : this.collapse()
  }
}
